import { IconButton } from "@zapier/design-system";
import { memo } from "react";

interface Props {
  href: string;
}

const BackButton = ({ href }: Props) => {
  return (
    <IconButton
      aria-label="Back to my canvases"
      name="arrowBigLeft"
      size="medium"
      variant="tertiary"
      onPress={() => {
        window.location.href = href;
      }}
    />
  );
};

export default memo(BackButton);
